/*
 * サブシステム名：売掛・買掛
 * 機能名：売掛一覧
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdSpreadSheet from '@/components/DdSpreadSheet'

import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import validators from '@/rahmen/validators'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import modals from '@/ddv2.library/modals'

const DdSearchList = () => import('@/components/DdSearchList')
const DdCodeTextBox = () => import('../../components/DdCodeTextBox.vue')
const DdDateRangeBox = () => import('@/components/DdDateRangeBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'NyukinList',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdSpreadSheet,
    DdSearchList,
    DdCodeTextBox,
    DdDateRangeBox,
    DdRadioButton,
    DdSubHeader,
    DdTextBox
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    rows: [],
    targetList: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isXlsDownloader: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    conditions: {
      seikyuYmdFrom: '',
      seikyuYmdTo: '',
      nyukinYoteiYmdFrom: '',
      nyukinYoteiYmdTo: '',
      searchTargetType: '',
      seikyusakiCd: ''
    },
    headersNyukinsakiList: header.mstTorihikisakiHeaders,
    modeKengen: 0,
    // スプレッドシートオプション
    option: {
      // minDimensions: [0, 50],
      toolbar: true,
      // テーブル最大高さ
      tableHeight: '600px',
      // テーブル最大横幅
      tableWidth: 'inherit',
      // 列追加
      allowInsertColumn: false,
      // 行追加※改行キーのみ
      allowManualInsertRow: false,
      // 列削除
      allowDeleteColumn: false,
      // 行削除
      allowDeleteRow: false,
      // 列ドラッグ
      columnDrag: false,
      // 行ドラッグ
      rowDrag: false,
      // ソート
      columnSorting: true,
      // スクロール有効化
      tableOverflow: true,
      // コンテキストメニュー
      contextmenu: false,
      // セル内HTML無効※ヘッダー改行のため有効
      stripHTML: false,
      // 計算式のサポート
      parseFormulas: true,
      // セル選択時の右下の■ドラッグでのコピー
      selectionCopy: true,
      // CSV出力
      allowExport: false,
      // フィルターオプション
      search: true,
      // ページネーションオプション
      pagination: 50,
      paginationOptions: [10, 25, 50, 100]
    },
    // 画面側からのエラーリスト
    outsideErrorList: []
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      nyukinsakiList: 'DDMasters/vwCMstTorihikisakiGetNyukinsaki'
    }),
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    filteredTorihikisakiList () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredNyukinsakiList () {
      const target = filter.dateFormatter(new Date())
      return this.nyukinsakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },

    computedColNumList () {
      var result = {}
      this.headers.forEach((elem, index) => {
        result[elem.name] = index
      })
      return result
    },

    // 画面制御系
    isOutputButtonDisabled () {
      return this.rows.length === 0
    },
    isBatchRegisterButtonDisabled () {
      if (this.modeKengen !== 2) {
        return false
      }
      const errorRows = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.errFlg === true
      })
      if (errorRows.length > 0) {
        return true
      }

      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true
      })
      if (saveTargetRow.length < 1) {
        return true
      }
      return false
    }
  },
  created () {
    if (![undefined, null, ''].includes(this.$route.params.seikyusakiId)) {
      this.conditions.seikyusakiId = parseFloat(this.$route.params.seikyusakiId)
    }
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.setHeader()
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('NyukinList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('NyukinList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('NyukinList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            // self.$set(self.conditions, 'nyukinYoteiYmdFrom', self.conditions.nyukinYoteiYmdFrom)
            // self.$set(self.conditions, 'nyukinYoteiYmdTo', self.conditions.nyukinYoteiYmdTo)
            this.$nextTick(function () {
              this.onSearchButtonClick()
              document.getElementById('heavy-element').style.display = ''
            })
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('NyukinList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('NyukinList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
              if (![undefined, null, ''].includes(self.conditions.seikyusakiCd)) {
                self.onSearchButtonClick()
              }
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onRefreshButtonClick: function (e) {
      this.rows = []
      this.$nextTick(() => {
        this.onSearchButtonClick()
      })
    },
    onSearchButtonClick: function (e) {
      this.rows = []
      this.selected = []
      this.page = 1
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2bcld0120/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          self.rows.map((elem, index) => {
            elem.editFlg = false
            elem.errFlg = false

            // スプレッドシート用編集
            // ※数値はsetHeaderにてmask対応済み
            elem.seikyuYmd = [undefined, null, ''].includes(elem.seikyuYmd) ? '' : filter.dateFormatter(elem.seikyuYmd)
            elem.seikyuYmdDisp = [undefined, null, ''].includes(elem.seikyuYmdDisp) ? '' : filter.dateFormatter(elem.seikyuYmdDisp)
            elem.nyukinYoteiYmd = [undefined, null, ''].includes(elem.nyukinYoteiYmd) ? '' : filter.dateFormatter(elem.nyukinYoteiYmd)
            elem.nyukinYoteiYmdDisp = [undefined, null, ''].includes(elem.nyukinYoteiYmdDisp) ? '' : filter.dateFormatter(elem.nyukinYoteiYmdDisp)
            elem.nyukinYmd = [undefined, null, ''].includes(elem.nyukinYmd) ? '' : filter.dateFormatter(elem.nyukinYmd)

            // Link作成
            elem.seikyusakiNmLink = `<a class="anker-link" href="#/bcl/urikakezan/list?scd=${elem.seikyusakiCd}">` + elem.seikyusakiNmDisp + '</a>'
            elem.seikyuNoLink = `<a class="anker-link" href="#/bil/seikyu/list?sno=${elem.seikyuNo}">` + elem.seikyuNoDisp + '</a>'
            if (![undefined, null, ''].includes(elem.shimeSeikyuNo)) {
              elem.shimeSeikyuNoLink = `<a class="anker-link" href="#/bil/seikyu/list?sno=${elem.shimeSeikyuNo}">` + elem.shimeSeikyuNo + '</a>'
            }
            // 運賃合計/基本運賃は数式管理とする。保存時には要数値変換。
            const y = index + 1
            const calcNyukinGokei = `=J${y}+K${y}+L${y}+M${y}*N${y}+O${y}+P${y}`
            elem.nyukinGokeiFormula = calcNyukinGokei
            const calcUrikakeZandaka = `=F${y}-(J${y}+K${y}+L${y}+M${y}*N${y}+O${y}+P${y})`
            elem.urikakeZandakaFormula = calcUrikakeZandaka
            return elem
          })

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              return {
              }
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },

    clear: function () {
      console.log('clear pushed')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.initBindVariables()
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    initBindVariables: function () {
      var today = new Date()
      var wSeikyusakiCd = ''
      var startDay = null
      var endDay = null
      if (![undefined, null, ''].includes(this.conditions.seikyusakiId)) {
        const wTorihikisaki = this.torihikisakiList.find((x) => x.id === this.conditions.seikyusakiId)
        if (wTorihikisaki) {
          wSeikyusakiCd = wTorihikisaki.torihikisakiCd
        }
      } else {
        startDay = date.getFirstDate(today.getFullYear(), today.getMonth())
        endDay = date.getLastDate(today.getFullYear(), today.getMonth())
      }
      this.conditions = {
        seikyuYmdFrom: '',
        seikyuYmdTo: '',
        nyukinYoteiYmdFrom: startDay,
        nyukinYoteiYmdTo: endDay,
        searchTargetType: '0',
        seikyusakiCd: wSeikyusakiCd
      }
      this.searchText = ''
      this.rows = []
      this.selected = []
      this.page = 1
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onRowClick: function (pSeikyuNo) {
      console.log('onRowClick', pSeikyuNo)
      // this.Effects.loadStart()
      // this.transition(0, { seikyuNo: pSeikyuNo })
    },
    onSaveButtonClick: function (e) {
      console.log('onSaveButtonClick', e)
      const self = this

      // 変更フラグONのみ対象
      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true && elem.errFlg !== true
      })
      if (saveTargetRow.length < 1) {
        modals.showAlert('COMI0010')
        return false
      }

      const parm = [saveTargetRow.length]
      modals.showConfirmYesNo('BCLQ0001', null, null, parm).then((ok) => {
        // 処理を続行しない場合は終了
        if (ok === true) {
          /**
           * 保存処理
           */
          this.targetList = saveTargetRow
          this.$nextTick(function () {
            self.saveAction()
          })
        }
      })

      return true
    },
    saveAction: function () {
      const self = this
      const opt = {
        registerRequestPromise: function () {
          return self.HttpClient.post('/api/v1/vwcd2bcld0120/BulkRegistration', self.targetList)
        },
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.Effects.loadComplete()
            if (data.isValid) {
              var param = [data.payload.length]
              self.$nextTick(function () {
                modals.showAlertOk('BILI0002', null, null, param).then((ok) => {
                  self.onSearchButtonClick()
                })
              })
            }
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return false
        },
        getSavedInputMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    // 登録前チェック
    registerValidate: function () {
      return true
    },

    onXlsOutputButtonClick: function (e) {
      this.isXlsDownloader = true

      var seikyuKihonIdList = []
      this.rows.forEach((x) => {
        seikyuKihonIdList.push(x.id)
      })
      const outputInfo = {
        idList: seikyuKihonIdList
      }

      this.HttpClient
        .requestFileByPost('/api/v1/vwcd2bcld0120/ExcelOutput', outputInfo)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('xlsdownload')
          this.isXlsDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '売掛一覧_' + ts + '.xlsx'
          elem.click()
        })
    },
    searchValidate: function () {
      console.log('●●searchVaridate:', this.$refs)
      var msg = null
      var errmsg = null
      msg = validators.compareDate(this.conditions.seikyuYmdFrom, this.conditions.seikyuYmdTo)
      if (msg !== undefined) {
        errmsg = '請求日の日付範囲に不備があります'
      }
      msg = validators.compareDate(this.conditions.nyukinYoteiYmdFrom, this.conditions.nyukinYoteiYmdTo)
      if (msg !== undefined) {
        if (errmsg !== null) {
          errmsg = errmsg + '<br />'
        }
        errmsg = errmsg + '入金予定日の日付範囲に不備があります'
      }
      if (errmsg !== null) {
        modals.showError(errmsg)
        return false
      }
      return true
    },

    /**
     * スプレッドシート制御
     * @returns
     */
    setHeader: function () {
      console.log('setHeader')
      const self = this
      return new Promise(resolve => {
        // 現在日付取得
        // const target = filter.dateFormatter(new Date())

        // --------------------------------------------------------------------------------
        // スプレッド用ドロップダウン作成
        // --------------------------------------------------------------------------------
        // 得意先
        /*
        var wkTokuisakiList = []
        const mTokuisakiList = this.torihikisakiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
        })
        const tTokuisakiList = mTokuisakiList.map(elem => {
          return elem.torihikisakiNm
        })
        wkTokuisakiList = wkTokuisakiList.concat(tTokuisakiList)
        */

        self.headers = [
          { title: '締め日', name: 'seikyuYmdDisp', type: 'customDate', validateType: 'Date', required: false, readOnly: true, width: '100px' },
          { title: 'サイト', name: 'saitoDisp', type: 'numeric', validateIntDigit: 14, validateDecimalDigit: 0, readOnly: true, align: 'right', width: '60px', mask: '#,##0' },
          { title: '入金予定日', name: 'nyukinYoteiYmdDisp', type: 'customDate', validateType: 'Date', required: false, readOnly: true, width: '100px' },
          // { title: '得意先', name: 'seikyusakiNm', type: 'dropdown', source: wkTokuisakiList, required: true, readOnly: true, width: '220px', align: 'left', autocomplete: true }
          { title: '得意先', name: 'seikyusakiNmLink', type: 'html', required: true, readOnly: true, width: '220px', align: 'left' },
          // { title: '請求番号', name: 'seikyuNo', type: 'text', validateType: 'Free', validateLength: 50, required: false, readOnly: true, align: 'left', width: '100px' },
          { title: '請求金額', name: 'konkaiSeikyuKingakuDisp', type: 'numeric', validateIntDigit: 14, validateDecimalDigit: 0, readOnly: true, align: 'right', width: '100px', mask: '#,##0 円' },
          // { title: '売掛残高', name: 'urikakeZandakaFormula', type: 'numeric', validateIntDigit: 14, validateDecimalDigit: 0, readOnly: true, align: 'right', width: '100px', mask: '#,##0 円' },
          // { title: '入金金額', name: 'nyukinGokeiFormula', type: 'numeric', validateIntDigit: 14, validateDecimalDigit: 0, readOnly: true, align: 'right', width: '100px', mask: '#,##0 円' },
          { title: '入金日', name: 'nyukinYmd', type: 'customDate', validateType: 'Date', required: true, readOnly: false, width: '110px' },
          { title: '振込金額', name: 'furikomiKingaku', type: 'numeric', validateIntDigit: 14, validateDecimalDigit: 0, readOnly: false, align: 'right', width: '90px', mask: '#,##0 円' },
          { title: '振込手数料', name: 'furikomiTesuryo', type: 'numeric', validateIntDigit: 14, validateDecimalDigit: 0, readOnly: false, align: 'right', width: '90px', mask: '#,##0 円' },
          { title: '調整', name: 'choseiKingaku', type: 'numeric', validateIntDigit: 14, validateDecimalDigit: 0, readOnly: false, align: 'right', width: '90px', mask: '#,##0 円' },
          { title: '相殺', name: 'sosaiKingaku', type: 'numeric', validateIntDigit: 14, validateDecimalDigit: 0, readOnly: false, align: 'right', width: '90px', mask: '#,##0 円' },
          { title: '手形', name: 'tegata', type: 'numeric', validateIntDigit: 14, validateDecimalDigit: 0, readOnly: false, align: 'right', width: '90px', mask: '#,##0 円' },
          { title: '現金', name: 'genkin', type: 'numeric', validateIntDigit: 14, validateDecimalDigit: 0, readOnly: false, align: 'right', width: '90px', mask: '#,##0 円' },
          { title: '小切手', name: 'kogitte', type: 'numeric', validateIntDigit: 14, validateDecimalDigit: 0, readOnly: false, align: 'right', width: '90px', mask: '#,##0 円' },
          { title: '摘要', name: 'tekiyo', type: 'text', required: false, readOnly: false, width: '200px' },
          { title: '請求番号', name: 'seikyuNoLink', type: 'html', required: false, readOnly: true, align: 'center', width: '110px' },
          { title: '締め請求番号', name: 'shimeSeikyuNoLink', type: 'html', required: false, readOnly: true, align: 'center', width: '110px' }
        ]
      })
    },
    onClickAddRow: function (p) {
      var activeC = this.$refs.ddSpreadSheet.getActiveCell()
      // 現在の並び順のデータ
      // var rowsCurrentOrder = this.$refs.ddSpreadSheet.getDataCurrentOrder()
      // 行追加先の位置を取得
      var pos = 0
      // 全選択状態なら先頭行に追加
      var isAllSelect = false
      if (!activeC) {
        // セル未選択
        pos = this.rows.length
      } else if (activeC.length > 3) {
        // セル選択
        pos = Math.max(...[activeC[1], activeC[3]]) + 1

        // 全選択かどうか判定
        var isSame1 = activeC[0] === 0
        var isSame2 = activeC[1] === 0
        var isSame3 = activeC[2] === this.headers.length - 1
        var isSame4 = activeC[3] === this.rows.length - 1
        isAllSelect = isSame1 && isSame2 && isSame3 && isSame4
        console.log('isAllSelect', isAllSelect)
      } else {
        // セル未選択
        pos = this.rows.length
      }
      var newrow = Object.assign({}, this.rows[pos - 1])
      // キーの初期化
      newrow.trNyukinId = -1
      newrow.trSeikyuKeshikomiKihonId = -1
      newrow.trNyukinKeshikomiId = -1
      newrow.trSeikyuKihonId = null
      // 設定値
      newrow.seikyuYmdDisp = ''
      newrow.saitoDisp = ''
      newrow.nyukinYoteiYmdDisp = ''
      newrow.konkaiSeikyuKingakuDisp = ''
      newrow.seikyusakiNmDisp = '同上'
      newrow.seikyuNoDisp = '同上'
      newrow.seikyusakiNmLink = `<a class="anker-link" href="#/bil/seikyu/list?scd=${newrow.seikyusakiCd}">${newrow.seikyusakiNmDisp}</a>`
      newrow.seikyuNoLink = `<a class="anker-link" href="#/bil/seikyu/list?sno=${newrow.seikyuNo}">${newrow.seikyuNoDisp}</a>`
      newrow.urikakeZandakaFormula = null
      newrow.nyukinGokeiFormula = null
      newrow.nyukinYmd = null
      newrow.genkin = null
      newrow.furikomiKingaku = null
      newrow.furikomiTesuryo = null
      newrow.choseiKingaku = null
      newrow.tegata = null
      newrow.sosaiKingaku = null
      newrow.kogitte = null
      newrow.tekiyo = null

      if (![undefined, null, 0].includes(pos)) {
        this.rows.splice(pos, 0, newrow)
      } else {
        this.rows.splice(this.rows.length, 0, newrow)
      }
      // this.rows.splice(pos + 1, 0, newrow)
      this.$nextTick(() => {
        setTimeout(() => {
          const ss = this.$refs.ddSpreadSheet
          if (!ss || !ss.jspreadsheetObj) return
          ss.setCellClass(0, pos, 'readonly')
        }, 0)
      })
    },
    /**
     * 読み取り専用設定
     */
    setReadonlyCell: function (rowData, columnName) {
      if (this.modeKengen === 0) {
        return true
      }
      // 行に 請求基本Idが埋まっていたら
      if (rowData && rowData.trSeikyuKihonId > 0) {
        if ([
          'nyukinYmd',
          'furikomiKingaku',
          'furikomiTesuryo',
          'choseiKingaku',
          'sosaiKingaku',
          'tegata',
          'genkin',
          'kogitte'
        ].includes(columnName)) {
          return true // ← そのセルを読み取り専用に
        }
      }
      return null
    }
  }
}
